import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'sn-query-builder',
  templateUrl: './query-builder.component.html',
  styleUrls: ['./query-builder.component.sass']
})
export class QueryBuilderComponent implements OnInit {
  @Input() conditionLimit = 10;
  @Input() sfObjectFields: any = [];
  @Output() conditionsE: EventEmitter<any> = new EventEmitter();

  // if you make any changes in this object be sure you also changed backend relationMap object
  RELATION_TYPES = {
    equals: 'equals',
    notEquals: 'not equal to',
    contains: 'contains',
    notContains: 'does not contain',
    // starts       : 'starts with',
    less: 'less than',
    greater: 'greater than',
    lessEqual: 'less or equal',
    greaterEqual: 'greater or equal'
  };

  INPUT_NAMES = {
    operator: 'operator',
    fieldName: 'fieldName',
    relation: 'relation',
    value: 'value'
  };

  ConditionForm: UntypedFormGroup;
  formOperatorsList: any = [];

  OPERATOR_SELECTORS_LIST = {
    AND: 'AND',
    OR: 'OR'
  };

  operatorsSuggestionList = [this.OPERATOR_SELECTORS_LIST.AND, this.OPERATOR_SELECTORS_LIST.OR];
  allRelationsSelectList = [
    this.RELATION_TYPES.equals,
    this.RELATION_TYPES.notEquals,
    this.RELATION_TYPES.contains,
    this.RELATION_TYPES.notContains,
    this.RELATION_TYPES.less,
    this.RELATION_TYPES.greater,
    this.RELATION_TYPES.lessEqual,
    this.RELATION_TYPES.greaterEqual
    // this.RELATION_TYPES.starts
  ];
  // stringRelationsSelectList = [this.RELATION_TYPES.equals, this.RELATION_TYPES.notEquals, this.RELATION_TYPES.contains, this.RELATION_TYPES.notContains, this.RELATION_TYPES.starts];
  // numberRelationsSelectList = [this.RELATION_TYPES.equals, this.RELATION_TYPES.notEquals, this.RELATION_TYPES.less,     this.RELATION_TYPES.greater,      this.RELATION_TYPES.lessEqual, this.RELATION_TYPES.greaterEqual];

  filteredRecordFieldsSuggestionLists = [];

  constructor(private fb: UntypedFormBuilder) {}

  ngOnInit() {
    this.initForm();
  }

  private initForm() {
    this.formOperatorsList = [];
    this.filteredRecordFieldsSuggestionLists = [];
    this.formOperatorsList.push(this.setEditRoleForForm(null));
    this.filteredRecordFieldsSuggestionLists.push(this.sfObjectFields || []);

    this.ConditionForm = this.fb.group({
      FConditions: this.fb.array([this.fb.group(this.formOperatorsList[0])])
    });
  }

  conditionsFormArray() {
    return this.ConditionForm.get('FConditions') as UntypedFormArray;
  }

  private setEditRoleForForm(_condition) {
    _condition = _condition || {};

    return {
      [this.INPUT_NAMES.operator]: [
        _condition.operator || this.OPERATOR_SELECTORS_LIST.AND,
        [Validators.required]
      ],
      [this.INPUT_NAMES.fieldName]: [_condition.fieldName || '', [Validators.required]],
      [this.INPUT_NAMES.relation]: [_condition.relation || this.RELATION_TYPES.equals, [Validators.required]],
      [this.INPUT_NAMES.value]: [_condition.value || '', [Validators.required]]
    };
  }

  addCondition() {
    if (this.formOperatorsList.length < this.conditionLimit) {
      const control = <UntypedFormArray>this.ConditionForm.controls['FConditions'];
      const roleItem = this.setEditRoleForForm(null);
      this.formOperatorsList.push(roleItem);
      control.push(this.fb.group(roleItem));

      this.filteredRecordFieldsSuggestionLists.push(this.sfObjectFields || []);
    }
  }

  deleteCondition(index) {
    this.formOperatorsList.splice(index, 1);

    const control = <UntypedFormArray>this.ConditionForm.controls['FConditions'];
    this.filteredRecordFieldsSuggestionLists.splice(index, 1);

    control.removeAt(index);
  }

  applyFilter() {
    let conditions = [];

    if (
      this.ConditionForm.controls['FConditions'] &&
      this.ConditionForm.controls['FConditions'].value.length
    ) {
      const conditionControlsCopy = JSON.parse(
        JSON.stringify(this.ConditionForm.controls['FConditions'].value)
      );

      conditions = conditionControlsCopy.filter((condition) => {
        return condition.operator && condition.fieldName && condition.relation && condition.value;
      });

      conditions.forEach((condition) => {
        for (let i = 0; i < this.sfObjectFields.length; i++) {
          if (
            this.sfObjectFields[i].soapType === 'xsd:string' &&
            this.sfObjectFields[i].name === condition.fieldName
          ) {
            // if condition type is string surround value of this condition in single quotes

            if (
              condition.relation === this.RELATION_TYPES.contains ||
              condition.relation === this.RELATION_TYPES.notContains
            ) {
              condition.value = `'%${condition.value}%'`;
            } else {
              condition.value = `'${condition.value}'`;
            }
          }
        }
      });

      this.conditionsE.emit({ conditionsList: conditions });
    }
  }

  resetFilter() {
    this.initForm();
    this.conditionsE.emit({ conditionsList: [] });
  }

  togglefilter(filterSection, btnShowFilter) {
    filterSection.classList.toggle('hide');
    btnShowFilter.classList.toggle('hide');
  }

  isFilterCanApply() {
    if (this.formOperatorsList.length) {
      return true;
    }

    return false;
  }

  // CHOSE FILTERS VALUE
  chooseSelectedValue(value, suggestionOperatorSelector, currentInput) {
    suggestionOperatorSelector.classList.remove('open');
    currentInput.value = value || this.OPERATOR_SELECTORS_LIST.AND;
  }

  onBlurSuggestionInputHandler(
    idx,
    condition,
    currentInput,
    inputType,
    suggestionSelectorTag,
    suggestionList,
    defaultValue = ''
  ) {
    setTimeout(() => {
      if (this.INPUT_NAMES.fieldName === inputType) {
        if (!this.sfObjectFields.some((field) => field.name === currentInput.value)) {
          currentInput.value = defaultValue;
        }
        this.changeFieldNameHandler(idx, currentInput);
      } else {
        if (!suggestionList.includes(currentInput.value)) {
          currentInput.value = defaultValue;
        }
      }

      condition.controls[inputType].setValue(currentInput.value);

      suggestionSelectorTag.classList.remove('open');
    }, 250);
  }

  // Field name
  changeFieldNameHandler(idx, currentInput) {
    if (currentInput.value) {
      this.filteredRecordFieldsSuggestionLists[idx] = this.sfObjectFields.filter((rField) =>
        rField.name.toLowerCase().includes(currentInput.value.toLowerCase())
      );
    } else {
      this.filteredRecordFieldsSuggestionLists[idx] = this.sfObjectFields;
    }
  }

  openSuggestionList(suggestionSelector) {
    suggestionSelector.classList.add('open');
  }

  // END CHOSE FILTERS VALUE
}
